module.exports = __webpack_public_path__ + "img/hxb.3b6f9660.png";